module.exports = __webpack_public_path__ + "img/mono_38.24988423.png";